// extracted by mini-css-extract-plugin
export default {"nameFilter":"PeopleListPage_nameFilter__Ugcxa","list":"PeopleListPage_list__tbTut"};